// removed by extract-text-webpack-plugin
module.exports = {"Container":"_mvgMe","ContainerActive":"_3178n","ContainerPrimary":"_2OjIW","ContainerSecondary":"_11OCu","Box1":"_3JPIP","Image":"_2axZS","Timings":"_3Ezan","Duration":"_2SGRG","Price":"_aOj5W","FLight":"_1Pj3S","FlightStop":"_3k92k","RefundStatus":"_3KUBm","Flight":"_2Ls9t","RightTick":"_31QDA","Line":"_FlFpJ","ArrivalDate":"_2Lxcz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/FlightTupleRoundTrip/RoundTupleInner/RoundTupleInner.scss
// module id = 735
// module chunks = 0